(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);

    function initBundleBuilder(section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const TIERS = [
        { min: 11, pct: 35, code: 'BUNDLE35' },
        { min: 8,  pct: 30, code: 'BUNDLE30' },
        { min: 5,  pct: 25, code: 'BUNDLE25' },
        { min: 3,  pct: 20, code: 'BUNDLE20' },
        { min: 2,  pct: 15, code: 'BUNDLE15' }
      ];
      function getTier(count) {
        for (const tier of TIERS) {
          if (count >= tier.min) return tier;
        }
        return null;
      }
      function getPct(count)  { const t = getTier(count); return t ? t.pct  : 0;    }
      function getCode(count) { const t = getTier(count); return t ? t.code : null; }

      const selected = new Set();
      const cards = section.querySelectorAll('[data-product-card]');
      const summary = section.querySelector('[data-summary]');
      const utilCount = section.querySelector('[data-util-count]');
      const selectAllUtil = section.querySelector('[data-select-all-btn]');
      const clearBtn = section.querySelector('[data-clear-btn]');
      const ctaBtn = section.querySelector('[data-add-to-cart]');
      const ctaLabel = section.querySelector('[data-cta-label]');
      const totalAvailable = cards.length;

      function nudgeText(count) {
        if (count === 0) return 'Add 2 to start saving';
        if (count === 1) return 'Add <em>1 more</em> to unlock 15% off';
        const currentPct = getPct(count);
        for (const tier of [...TIERS].reverse()) {
          if (tier.pct > currentPct) {
            const needed = tier.min - count;
            return needed === 1
              ? `Add <em>1 more</em> to reach ${tier.pct}% off`
              : `Add <em>${needed} more</em> to reach ${tier.pct}% off`;
          }
        }
        // At max tier. Distinguish between "actually has the full collection"
        // (every available product selected) vs. "just hit the top tier."
        if (count === totalAvailable) {
          return `<em>The full collection.</em> 35% off.`;
        }
        return `<em>Maximum reward unlocked.</em> 35% off.`;
      }

      function money(n) {
        if (n % 1 === 0) return '$' + n.toLocaleString();
        return '$' + n.toFixed(2);
      }

      function update() {
        const items = [];
        cards.forEach(card => {
          const id = card.dataset.productId;
          const isSelected = selected.has(id);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          if (isSelected) {
            items.push({
              id: id,
              price: parseFloat(card.dataset.productPrice) || 0,
              title: card.dataset.productTitle
            });
          }
        });

        const count = items.length;
        const subtotal = items.reduce((s, p) => s + p.price, 0);
        const pct = getPct(count);
        const final = +(subtotal * (1 - pct / 100)).toFixed(2);

        if (utilCount) utilCount.innerHTML = `<strong>${count}</strong> of ${totalAvailable} selected`;
        if (selectAllUtil) {
          selectAllUtil.textContent = (count === totalAvailable) ? 'All selected' : 'Select all';
          selectAllUtil.disabled = (count === totalAvailable);
        }
        if (clearBtn) clearBtn.disabled = (count === 0);

        const sumCount = section.querySelector('[data-summary-count]');
        const sumNudge = section.querySelector('[data-summary-nudge]');
        const sumOld = section.querySelector('[data-summary-old]');
        const sumNew = section.querySelector('[data-summary-new]');
        const sumPct = section.querySelector('[data-summary-pct]');

        if (sumCount) sumCount.textContent =
          count === 0 ? '0 selected' : `${count} ${count === 1 ? 'product' : 'products'} selected`;
        if (sumNudge) sumNudge.innerHTML = nudgeText(count);
        if (sumOld) {
          sumOld.textContent = subtotal === 0 ? '' : money(subtotal);
          sumOld.classList.toggle('is-visible', pct > 0);
        }
        if (sumNew) sumNew.textContent = count === 0 ? '$0' : money(final);
        if (sumPct) sumPct.textContent = pct > 0 ? pct + '% off' : '';

        if (summary) summary.classList.toggle('is-visible', count > 0);
        if (ctaBtn) ctaBtn.disabled = (count < 2);

        // Refresh preset "active" states based on current selection
        if (typeof refreshPresetActiveStates === 'function') {
          refreshPresetActiveStates();
        }
      }

      function toggle(card) {
        const id = card.dataset.productId;
        if (selected.has(id)) selected.delete(id);
        else selected.add(id);
        card.classList.remove('is-pulse');
        void card.offsetWidth;
        card.classList.add('is-pulse');
        update();
      }

      function selectAll() {
        cards.forEach((card, i) => {
          const id = card.dataset.productId;
          if (selected.has(id)) return;
          setTimeout(() => {
            selected.add(id);
            card.classList.remove('is-pulse');
            void card.offsetWidth;
            card.classList.add('is-pulse');
            update();
          }, i * 35);
        });
      }

      async function clearAll() {
        // Disable button during the operation
        if (clearBtn) clearBtn.disabled = true;

        // If the customer has bundle items in their cart, remove those too.
        // This keeps the bundle builder honest about cart state.
        // Non-bundle items (gift cards, etc.) are preserved.
        try {
          const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            const updates = {};
            cart.items.forEach(item => {
              if (bundleEligibleIds.has(item.variant_id)) {
                updates[item.variant_id] = 0;
              }
            });
            // Only call update if there's something to remove
            if (Object.keys(updates).length > 0) {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ updates: updates })
              });
              // Notify any cart drawer / mini-cart UI that the cart changed
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
          }
        } catch (err) {
          console.warn('[Bundle Builder] Cart clear failed:', err);
          // Continue anyway — we'll still clear the JS selection
        }

        // Clear the in-page selection
        selected.clear();
        update();
      }

      // Build a Set of variant IDs that are bundle-eligible (i.e., in the
      // configured Bundle Eligible collection). Used to count cart items
      // that should contribute toward the bundle discount tier.
      const bundleEligibleIds = new Set();
      cards.forEach(card => {
        bundleEligibleIds.add(parseInt(card.dataset.productId, 10));
      });

      async function addToCart() {
        const newSelections = [...selected].map(id => parseInt(id, 10));
        if (newSelections.length < 2) return;

        ctaBtn.disabled = true;
        if (ctaLabel) ctaLabel.textContent = 'Adding...';

        try {
          // Step 1: Read the current cart to dedupe against existing items.
          // This MUST complete before the add request because we need to
          // know which selections are already in the cart.
          const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          if (!cartRes.ok) throw new Error('Cart read failed');
          const cart = await cartRes.json();

          const existingIds = new Set(cart.items.map(item => item.variant_id));
          const itemsToAdd = newSelections
            .filter(id => !existingIds.has(id))
            .map(id => ({ id: id, quantity: 1 }));

          // Count existing bundle-eligible items in the cart
          let existingBundleCount = 0;
          cart.items.forEach(item => {
            if (bundleEligibleIds.has(item.variant_id)) {
              existingBundleCount += item.quantity;
            }
          });

          // Step 2: Add the new items
          if (itemsToAdd.length > 0) {
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: itemsToAdd })
            });
            if (!addRes.ok) throw new Error('Cart add failed');
          }

          // Step 3: Apply the discount code AFTER items are in the cart.
          // Shopify validates eligibility at the moment /discount/CODE is
          // requested, so the cart must already contain the qualifying items.
          //
          // We fire this in parallel with opening the drawer below, since
          // the drawer's own buildCart will fetch the cart fresh and our
          // re-prime listener will dispatch cart:build once the discount
          // is committed.
          const totalBundleCount = existingBundleCount + itemsToAdd.length;
          let primePromise = Promise.resolve();
          if (totalBundleCount >= 2) {
            const targetCode = getCode(totalBundleCount);
            primePromise = applyDiscountInBackground(targetCode).then(() => {
              lastAppliedCode = targetCode;
              // Force the drawer (if open) to re-render with the discount visible
              document.dispatchEvent(new CustomEvent('cart:build'));
            });
          }

          // Step 4: Open the drawer immediately. It will render with current
          // cart state. The prime above is running in parallel and the
          // cart:build dispatch will refresh the drawer when it finishes.
          openCartDrawer();

          // Reset CTA state
          if (ctaLabel) ctaLabel.textContent = 'Add to cart';
          ctaBtn.disabled = false;
          selected.clear();
          cards.forEach(c => c.setAttribute('aria-pressed', 'false'));

          // Wait for the prime to finish before syncing selection state from cart
          await primePromise;
          await syncFromCart();

        } catch (err) {
          console.error('[Bundle Builder]', err);
          if (ctaLabel) ctaLabel.textContent = 'Try again';
          ctaBtn.disabled = false;
          setTimeout(() => {
            if (ctaLabel) ctaLabel.textContent = 'Add to cart';
          }, 2000);
        }
      }

      // Apply a discount code to the cart session without navigating away.
      // Uses a fetch to /discount/CODE which is Shopify's standard discount-
      // application URL. Shopify processes the request and applies the code
      // to the session, then returns a redirect (which we don't follow).
      //
      // Unlike the iframe approach (which needs a buffer because the iframe
      // load event fires before Shopify finishes processing), fetch resolves
      // only after Shopify completes the request. So no buffer needed.
      function applyDiscountInBackground(code) {
        return new Promise((resolve) => {
          let resolved = false;
          const finish = () => {
            if (resolved) return;
            resolved = true;
            resolve();
          };

          fetch('/discount/' + encodeURIComponent(code), {
            method: 'GET',
            credentials: 'same-origin',
            redirect: 'manual'
          })
            .then(finish)
            .catch(finish);

          // Safety timeout in case fetch hangs
          setTimeout(finish, 2500);
        });
      }

      // Apply the top eligible discount code to the cart session.
      //
      // Shopify only keeps ONE active discount code on a cart at a time, so
      // priming multiple codes in parallel is unreliable — whichever request
      // Shopify processes last wins, and parallel requests don't have
      // deterministic ordering. Instead we just apply the code for the
      // current cart count. When the customer removes items past a tier
      // boundary, our cart:updated listener re-primes with the appropriate
      // lower code.
      //
      // Returns the code that was applied.
      async function primeAllEligibleCodes(count) {
        const targetCode = getCode(count);
        if (!targetCode) return null;
        await applyDiscountInBackground(targetCode);
        return targetCode;
      }

      // Open the theme's cart drawer. The theme creates a single CartDrawer
      // at page load (in HeaderSection.initDrawers), which listens for the
      // 'cart:open' event. We dispatch that instead of creating a new
      // CartDrawer instance — instantiating new ones stacks duplicate
      // listeners on document for cart:quantity events, causing each minus
      // click to fire multiple /cart/change.js requests (one per stacked
      // listener), most of which return 400 because the line is already
      // being modified.
      function openCartDrawer() {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }

      cards.forEach(card => card.addEventListener('click', () => toggle(card)));
      if (selectAllUtil) selectAllUtil.addEventListener('click', selectAll);
      if (clearBtn) clearBtn.addEventListener('click', clearAll);
      if (ctaBtn) ctaBtn.addEventListener('click', addToCart);

      // ---- Presets (curated entry points in the hero) ----
      const presetButtons = section.querySelectorAll('[data-preset]');

      // Build an ID set per preset (resolved once at init)
      const presetData = [];
      presetButtons.forEach(btn => {
        const isSelectAll = btn.dataset.presetSelectAll === 'true';
        let ids = new Set();
        if (isSelectAll) {
          cards.forEach(card => ids.add(card.dataset.productId));
        } else {
          const handles = (btn.dataset.presetHandles || '')
            .split(',')
            .map(h => h.trim().toLowerCase())
            .filter(Boolean);
          handles.forEach(handle => {
            cards.forEach(card => {
              if (card.dataset.productHandle === handle) {
                ids.add(card.dataset.productId);
              }
            });
          });
        }
        presetData.push({ btn: btn, ids: ids, isSelectAll: isSelectAll });
      });

      // Check whether the current selection matches any preset exactly
      function refreshPresetActiveStates() {
        presetData.forEach(p => {
          const sameSize = (p.ids.size === selected.size && p.ids.size > 0);
          let isMatch = sameSize;
          if (sameSize) {
            for (const id of p.ids) {
              if (!selected.has(id)) { isMatch = false; break; }
            }
          }
          p.btn.setAttribute('data-active', isMatch ? 'true' : 'false');
        });
      }

      // Active state refresh is called from inside update() below

      presetButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const isActive = btn.dataset.active === 'true';

          // Clear current selection
          selected.clear();
          cards.forEach(c => c.setAttribute('aria-pressed', 'false'));

          // If preset was already active, this click is the "undo" — just clear
          if (isActive) {
            update();
            return;
          }

          // Otherwise: scroll down and apply the preset
          const builder = section.querySelector('.ttn-bundle__builder');
          if (builder) {
            builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          const isSelectAll = btn.dataset.presetSelectAll === 'true';

          setTimeout(() => {
            if (isSelectAll) {
              // For "Everything" preset, no shuffle needed (nothing excluded)
              selectAll();
              return;
            }

            const handlesAttr = btn.dataset.presetHandles || '';
            const handles = handlesAttr
              .split(',')
              .map(h => h.trim().toLowerCase())
              .filter(Boolean);
            if (handles.length === 0) return;

            // Shuffle selected products to the top using FLIP animation,
            // then apply the staggered selection animation.
            shuffleToTop(handles, () => {
              let staggerIndex = 0;
              handles.forEach(handle => {
                cards.forEach(card => {
                  if (card.dataset.productHandle === handle) {
                    setTimeout(() => {
                      selected.add(card.dataset.productId);
                      card.classList.remove('is-pulse');
                      void card.offsetWidth;
                      card.classList.add('is-pulse');
                      update();
                    }, staggerIndex * 60);
                    staggerIndex++;
                  }
                });
              });
              update();
            });
          }, 300);
        });
      });

      // ---- FLIP-based grid shuffle ----
      // Reorders the grid so products matching the given handles appear first,
      // animating each card from its old position to its new one.
      function shuffleToTop(handles, onComplete) {
        const grid = section.querySelector('[data-grid]');
        if (!grid) { if (onComplete) onComplete(); return; }

        // First: capture each card's current position
        const firstRects = new Map();
        cards.forEach(card => {
          firstRects.set(card, card.getBoundingClientRect());
        });

        // Reorder DOM: move matching cards to front in the order given by handles
        const lowerHandles = handles.map(h => h.trim().toLowerCase());
        const matched = [];
        const unmatched = [];
        // Build matched list in handle order
        lowerHandles.forEach(handle => {
          cards.forEach(card => {
            if (card.dataset.productHandle === handle && !matched.includes(card)) {
              matched.push(card);
            }
          });
        });
        // Build unmatched list preserving current visual order
        cards.forEach(card => {
          if (!matched.includes(card)) unmatched.push(card);
        });

        const newOrder = [...matched, ...unmatched];
        const fragment = document.createDocumentFragment();
        newOrder.forEach(card => fragment.appendChild(card));
        grid.appendChild(fragment);

        // Last: capture each card's new position
        // Force layout flush by reading offsetHeight
        void grid.offsetHeight;

        const lastRects = new Map();
        cards.forEach(card => {
          lastRects.set(card, card.getBoundingClientRect());
        });

        // Invert + Play: animate each card from its old position to its new one
        cards.forEach(card => {
          const first = firstRects.get(card);
          const last = lastRects.get(card);
          const dx = first.left - last.left;
          const dy = first.top - last.top;

          if (dx === 0 && dy === 0) return; // didn't actually move

          card.style.transition = 'none';
          card.style.transform = `translate(${dx}px, ${dy}px)`;
          // Force a reflow so the browser applies the inverted position
          void card.offsetHeight;

          // Play: animate to natural position (transform: none)
          card.style.transition = 'transform 0.55s cubic-bezier(0.32, 0.72, 0, 1)';
          card.style.transform = '';
        });

        // Clean up inline styles after the animation completes
        setTimeout(() => {
          cards.forEach(card => {
            card.style.transition = '';
            card.style.transform = '';
          });
          if (onComplete) onComplete();
        }, 580);
      }

      // ---- Cart sync (simplified architecture) ----
      //
      // The bundle builder now operates with a clean separation from the cart
      // drawer's lifecycle:
      //
      //   • Page load → sync the bundle builder's state from the cart
      //   • Customer clicks Add to cart → add items, sync, open drawer
      //   • Drawer opens → hide the sticky bar (drawer takes full attention)
      //   • Drawer closes → re-sync, recalibrate discount, show sticky bar
      //
      // We deliberately do NOT listen for cart change events from the theme
      // during drawer interactions. Racing the drawer's render cycle was
      // causing visual bugs (empty drawer, stuck quantities). Instead we
      // wait for the drawer to fully close, then catch up in one clean pass.

      let lastAppliedCode = null;

      // Detect whether the cart drawer is currently open.
      // Impulse theme adds 'js-drawer-open' to the <html> element when open.
      function isDrawerOpen() {
        return document.documentElement.classList.contains('js-drawer-open');
      }

      // Hide / show the sticky summary bar based on drawer state.
      function setStickyBarVisibility(drawerOpen) {
        const summary = section.querySelector('[data-summary]');
        if (!summary) return;
        if (drawerOpen) {
          summary.classList.add('is-hidden-by-drawer');
        } else {
          summary.classList.remove('is-hidden-by-drawer');
        }
      }

      // Read /cart.js and reconcile the bundle builder's selection state
      // and discount tier. This is the single source of truth for syncing.
      async function syncFromCart() {
        try {
          const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          if (!res.ok) return;
          const cart = await res.json();

          const cartBundleIds = new Set();
          let cartBundleCount = 0;
          if (cart.items) {
            cart.items.forEach(item => {
              if (bundleEligibleIds.has(item.variant_id)) {
                cartBundleIds.add(String(item.variant_id));
                cartBundleCount += item.quantity;
              }
            });
          }

          // Replace selection with cart contents
          selected.clear();
          cards.forEach(c => c.setAttribute('aria-pressed', 'false'));
          cartBundleIds.forEach(id => selected.add(id));
          update();

          // Recalibrate the discount: prime all eligible codes (low → high)
          // so that subsequent removals can downgrade automatically without
          // our intervention. Only fires the priming when the top tier has
          // changed since the last apply (avoids unnecessary work).
          if (cartBundleCount >= 2) {
            const targetCode = getCode(cartBundleCount);
            if (targetCode && targetCode !== lastAppliedCode) {
              const finalCode = await primeAllEligibleCodes(cartBundleCount);
              lastAppliedCode = finalCode;
            }
          }
        } catch (err) {
          console.warn('[Bundle Builder] Cart sync failed:', err);
        }
      }

      // Poll for drawer state transitions. When the drawer opens, hide the
      // sticky bar. When it closes, sync from cart and show the sticky bar.
      let wasDrawerOpen = false;
      setInterval(() => {
        const drawerOpenNow = isDrawerOpen();
        if (drawerOpenNow !== wasDrawerOpen) {
          if (drawerOpenNow) {
            // Drawer just opened — hide sticky bar
            setStickyBarVisibility(true);
          } else {
            // Drawer just closed — sync, then show sticky bar.
            // Brief delay so the drawer's own close-cleanup runs first.
            setTimeout(() => {
              syncFromCart().then(() => {
                setStickyBarVisibility(false);
              });
            }, 150);
          }
        }
        wasDrawerOpen = drawerOpenNow;
      }, 200);

      // Re-prime discount codes when cart changes during in-drawer removal.
      // Shopify only keeps ONE active discount code on a cart at a time. When
      // BUNDLE35 fails eligibility (cart drops below 11), Shopify drops it
      // entirely — there's no automatic fallback. We have to actively apply
      // the next-lower code.
      //
      // Strategy: fire re-prime IMMEDIATELY on cart:updated (no debounce),
      // racing against the theme's buildCart fetch. If our re-prime finishes
      // first, the buildCart fetch sees the discounted cart and renders the
      // correct state in a single pass. If buildCart finishes first, we
      // dispatch cart:build to trigger a second rebuild with the discount.
      //
      // This removes the visible flash in the common case where re-prime
      // completes before buildCart.
      let reprimeInFlight = false;
      document.addEventListener('cart:updated', async (evt) => {
        // If a re-prime is already in flight, skip — the latest cart state
        // will be picked up when it completes.
        if (reprimeInFlight) return;

        try {
          reprimeInFlight = true;

          // Use the cart from the event if available (saves a round-trip)
          let cart = evt.detail && evt.detail.cart;
          if (!cart) {
            cart = await fetch('/cart.js', { credentials: 'same-origin' })
              .then(r => r.json());
          }

          let bundleCount = 0;
          cart.items.forEach(item => {
            if (bundleEligibleIds.has(item.variant_id)) {
              bundleCount += item.quantity;
            }
          });

          // Below 2: no discount applies
          if (bundleCount < 2) {
            lastAppliedCode = null;
            return;
          }

          const targetCode = getCode(bundleCount);
          if (!targetCode) return;
          if (targetCode === lastAppliedCode) return;

          console.log('[Bundle Builder] Re-priming for', bundleCount, 'items →', targetCode);
          const reprimeStart = Date.now();

          // Mask the drawer during the transition so customer doesn't see
          // the flash between old and new discount states.
          document.body.classList.add('ttn-cart-repricing');

          await applyDiscountInBackground(targetCode);
          lastAppliedCode = targetCode;

          // Always dispatch cart:build to ensure the drawer reflects the
          // discounted state. The theme's buildCart deduplicates concurrent
          // fetches, so this is safe even if a buildCart is already in flight.
          document.dispatchEvent(new CustomEvent('cart:build'));
          console.log('[Bundle Builder] Re-prime + rebuild:', Date.now() - reprimeStart, 'ms');

          // Remove the mask after a short delay so the cart:build rebuild
          // has a moment to settle into the DOM before the fade-in.
          setTimeout(() => {
            document.body.classList.remove('ttn-cart-repricing');
          }, 250);
        } catch (err) {
          console.warn('[Bundle Builder] Re-prime failed:', err);
          document.body.classList.remove('ttn-cart-repricing');
        } finally {
          reprimeInFlight = false;
        }
      });

      // Initial setup: sync from cart on page load.
      update();
      syncFromCart();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-ttn-sale]').forEach(initSalePage);

    function initSalePage(section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var addButtons = section.querySelectorAll('[data-add]');

      // ---- Add to cart (same events the Bundle Builder uses) ----
      function openCartDrawer() {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }

      addButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var variantId = parseInt(btn.dataset.variantId, 10);
          if (!variantId || btn.disabled) return;

          var originalLabel = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function(res) {
              if (!res.ok) throw new Error('Add failed');
              return res.json();
            })
            .then(function() {
              btn.textContent = 'Added ✓';
              btn.classList.add('is-added');
              openCartDrawer();
              setTimeout(function() {
                btn.textContent = originalLabel;
                btn.classList.remove('is-added');
                btn.disabled = false;
              }, 2000);
            })
            .catch(function(err) {
              console.error('[Sale Page]', err);
              btn.textContent = 'Try again';
              btn.disabled = false;
              setTimeout(function() { btn.textContent = originalLabel; }, 2000);
            });
        });
      });

      // ---- Jump nav: smooth scroll to chapters ----
      section.querySelectorAll('[data-jump]').forEach(function(link) {
        link.addEventListener('click', function(e) {
          var target = document.querySelector(link.getAttribute('href'));
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
